let _mapCointainer = null;
const _eventsQueue = [];

export function storeMapReference(element) {
  _mapCointainer = element;
}

export function consumeAllEvents() {
  const length = _eventsQueue.length;
  for (let i = 0; i < length; i++) {
    triggerEvent(_eventsQueue.pop());
  }
}

export function registerEvent(event) {
  if (!_mapCointainer) {
    _eventsQueue.push(event);
  } else {
    triggerEvent(event);
  }
}

function triggerEvent(event) {
  _mapCointainer.dispatchEvent(event);
}
